import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgIf} from "@angular/common";
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-modal',
  imports: [
    NgIf,
    TranslateModule
  ],
  templateUrl: './confirmation-modal.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {

  constructor(private router: Router) {}

  private _isVisible: boolean = false;

  @Input() header: string = '';
  @Input() description: string = '';
  @Input() navigateToThankYou: boolean = true;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();


  @Input()
  get isVisible(): boolean {
    return this._isVisible;
  }

  set isVisible(value: boolean) {
    if (this._isVisible !== value) {
      this._isVisible = value;
      this.isVisibleChange.emit(this._isVisible);
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirm.emit();
    if (this.navigateToThankYou) {
      this.router.navigateByUrl('/thank-you', { skipLocationChange: true });
    }
  }
}
